import { AssignmentsWorkTypeMap } from 'src/interfaces/assignment.types';
import authService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { useGetK5PastWorkStudentAssignmentsQuery } from 'src/store/api/assignment';
import { useCurrentAppViewSelector } from 'src/store/features';

import { useIsMiddleSchoolView } from '../use-is-middle-school-view';

export const useK5PastWorkStudentAssignments = () => {
  const currentAppView = useCurrentAppViewSelector();

  const isMiddleSchoolView = useIsMiddleSchoolView();

  const isTeacher = authService.isTeacher();
  const shouldSkipQuery =
    isTeacher || currentAppView === null || isMiddleSchoolView;

  const queryResult = useGetK5PastWorkStudentAssignmentsQuery(
    {
      workType: AssignmentsWorkTypeMap.PAST_WORK,
      domain: null,
      includeSingleSessionCodes: true,
    },
    {
      skip: shouldSkipQuery,
    },
  );

  if (queryResult.error) {
    loggerService.logError(
      'Something went wrong during K-5 Past-Work student assignments query',
      queryResult.error,
    );
  }

  return queryResult;
};
